import React, { useEffect, useLayoutEffect } from "react";
import SuccessfulSubmit from "../../../components/cards/SuccessfulSubmit";
import { useDispatch, useSelector } from "react-redux";
import MainContainer from "../../../components/container/MainContainer";
import { CircleCheckBigIcon, CircleX } from "lucide-react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getProject } from "../../../features/projectsSlice";
import Loading from "../../../components/loading/Loading";
import loadStatus from "../../../util/loadStatus";
import NetworkError from "../../error/NetworkError";

const PDOReviewSubmit = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.user.userInfo);
  const project = useSelector((state) => state.projects.selected);
  const projectLoad = useSelector((state) => state.projects.load.getProject);

  useEffect(() => {
    if (!project.id) {
      dispatch(getProject(id));
    }
  }, [project]);

  useLayoutEffect(() => {
    if (project.id && project.stage.step_number === -1) {
      return;
    } else if (
      (project.id && project.stage.step_number < 7) ||
      (project.id && project.stage.step_number > 7)
    ) {
      return navigate("/requests/pdo-approvals", { replace: true });
    }
  }, [user, project]);

  if (!project.id && projectLoad === loadStatus.loading) {
    return <Loading />;
  }

  if (projectLoad === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer>
      {project.id && (
        <>
          {project.status.toLowerCase() === "canceled" ? (
            <SuccessfulSubmit
              message={`You have cancelled the project Successfully`}
              icon={CircleX}
              link="/requests/provincial-approvals"
              linkName="Go to Provincial Approvals"
              red
            />
          ) : (
            <SuccessfulSubmit
              message={`Your Review Concept Paper has been submitted to the ${project.province} Provincial Council`}
              icon={CircleCheckBigIcon}
              link="/requests/pdo-approvals"
              linkName="Go to PDO Approvals"
            />
          )}
        </>
      )}
    </MainContainer>
  );
};

export default PDOReviewSubmit;
